import Analytics from 'analytics';
import segmentPlugin from '@analytics/segment';

const analytics = Analytics({
  app: 'QA Assistant',
  plugins: [
    segmentPlugin({
      writeKey: 'b5Ica4fBaZ4IyQWoPp1UwJc2mxiJfL8b',
    }),
  ],
});

export const sendSegment = analytics.track;
export const identifySegment = analytics.identify;
